import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EqualizerIcon from '@mui/icons-material/Equalizer';
import TableChartIcon from '@mui/icons-material/TableChart';
import GetAppIcon from '@mui/icons-material/GetApp';

import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Tooltip from "@mui/material/Tooltip";

import { useHistory } from "react-router-dom";

import { NavLink } from 'react-router-dom';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useSelector, useDispatch } from "react-redux";
import { setOrderFromDate } from "store/actions/restaurant";
import { useConfirm } from "material-ui-confirm";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import TransactionDeleteDialog from "./TransactionDeleteDialog";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  rightSpacer: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
  viewToggle: {
    marginLeft: theme.spacing(2),
  }
}));

const TransactionsToolbar = (props) => {
  const { className, onViewChange, viewMode, onDownloadCSV, ...rest } = props;
  const classes = useStyles();
  const history = useHistory();
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");

  const setOrderDate = (date) => dispatch(setOrderFromDate(date));
  const selectedDate = useSelector(
    (state) => state.restaurant.orderFromDate
  );
  
  // Ensure selectedDate is a valid Date object
  const validSelectedDate = selectedDate instanceof Date && !isNaN(selectedDate) ? selectedDate : new Date();
  const selectedTransactionIds = useSelector((state) => state.transaction.ids);
  const showSuccessMessage = (msg) => dispatch(showSuccessSnackbar(msg));
  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));

  const handleDateChange = (date) => {
    console.log("date", date);  
    setOrderDate(date);
    history.push("/staffActivities");
  };

  const deleteTransactions = () => {
    //console.log("selectedTransactionIds", selectedTransactionIds);
    if (selectedTransactionIds && selectedTransactionIds.length === 0) {
      showErrorMessage("Please select a transaction.");
      return;
    }

    setDeleteDialogOpen(true);

    // confirm({ description: "You are about to delete transactions!" })
    //   .then(() => {
    //     setButtonLoading(true);
    //     props.deleteProxy(selectedTransactionIds, () => {
    //       setButtonLoading(false);
    //     })
    //   })
    //   .catch(() => {});
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  const deleteTran = () => {
    if (deleteReason.length === 0) {
      showErrorMessage('Please select or enter a reason.');
      return;
   }
    props.deleteProxy(deleteReason);
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />

        <NavLink to={'/transactions'}>
          <Button variant="outlined" color="primary">Transactions</Button>
        </NavLink>
        <span className={classes.rightSpacer} />

        <Tooltip title="Download CSV">
          <Button 
            variant="outlined" 
            color="primary"
            onClick={onDownloadCSV}
            startIcon={<GetAppIcon />}
            className={classes.rightSpacer}
          >
            Export CSV
          </Button>
        </Tooltip>

        <ButtonGroup className={classes.viewToggle}>
          <Tooltip title="Table View">
            <Button 
              variant={viewMode === 'table' ? 'contained' : 'outlined'} 
              color="primary"
              onClick={() => onViewChange('table')}
            >
              <TableChartIcon />
            </Button>
          </Tooltip>
          <Tooltip title="Report View">
            <Button 
              variant={viewMode === 'report' ? 'contained' : 'outlined'} 
              color="primary"
              onClick={() => onViewChange('report')}
            >
              <EqualizerIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>

        {/* <IconButton
          aria-label="delete"
          onClick={deleteTransactions}
          disabled={buttonLoading}
        >
          <DeleteIcon />
        </IconButton> */}

      </div>
      <div className={classes.row}>
        {/* <SearchInput
          className={classes.searchInput}
          placeholder="Search order"
        /> */}

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            autoOk={true}
            id="date-picker-inline"
            label="Activity Date "
            value={validSelectedDate}
            onChange={handleDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </LocalizationProvider>
        <span className={classes.spacer} />
        <TransactionDeleteDialog open={deleteDialogOpen} deleteProxy={deleteTran} close={closeDeleteDialog} updateReason={setDeleteReason} reason={deleteReason}/>
      </div>
    </div>
  );
};

TransactionsToolbar.propTypes = {
  className: PropTypes.string,
  onViewChange: PropTypes.func.isRequired,
  viewMode: PropTypes.string.isRequired,
  onDownloadCSV: PropTypes.func,
};

export default TransactionsToolbar;
